import React from "react";
import styled from "styled-components";
import {
  Bullets,
  BulletsClassName,
  IconName,
  Theme,
  colors,
} from "@literati/public-ui-shared-react";
import GuidedSignUpCollapsible, {
  GuidedSignUpCollapsibleClassName,
  headingStyles,
} from "components/GuidedSignUp/GuidedSignUpCollapsible";

const CLASS_BASE = "plan-selection-prepaid-details-collapsible";
export const PlanSelectionPrepaidDetailsCollapsibleClassName = {
  BASE: CLASS_BASE,
  HEADING: `${CLASS_BASE}-heading`,
  GUARANTEE: `${CLASS_BASE}-guarantee`,
} as const;

const StyledDiv = styled.div`
  padding: 0.5rem 1rem;
  background: ${colors.periwinkleTint5};
  border-radius: 4px;

  .${GuidedSignUpCollapsibleClassName.CHILDREN} {
    padding: 0rem 1rem 0 0;
  }

  .${GuidedSignUpCollapsibleClassName.TRIGGER} {
    &:focus {
      outline: 2px solid ${colors.transparent};
    }
    &:focus-visible {
      outline: 2px solid ${colors.tealShade2};
    }
  }
`;

const StyledGuidedSignUpCollapsible = styled(GuidedSignUpCollapsible)`
  .${GuidedSignUpCollapsibleClassName.CHILDREN} {
    padding-top: 0;
  }
`;

const Heading = styled.h2`
  ${headingStyles}
  margin: 1.5rem 0 0;
  padding-bottom: 0.5rem;
`;

const StyledBullets = styled(Bullets)`
  justify-content: flex-start;
  padding: 0.5rem 0 2rem;

  .${BulletsClassName.BULLET} {
    font-size: 0.875rem;
  }
`;

export interface PlanSelectionPrepaidDetailsCollapsibleProps {
  className?: string;
  initialIsOpen?: boolean;
}

export const PlanSelectionPrepaidDetailsCollapsible = ({
  className = "",
  initialIsOpen = false,
}: PlanSelectionPrepaidDetailsCollapsibleProps) => {
  const cls = PlanSelectionPrepaidDetailsCollapsibleClassName;

  return (
    <Theme>
      <StyledDiv className={`${cls.BASE} ${className}`}>
        <StyledGuidedSignUpCollapsible
          bgColor="periwinkleTint5"
          heading="Plan Details"
          initialIsOpen={initialIsOpen}
        >
          <StyledBullets
            iconProps={{
              name: IconName.STAR,
              fill: "periwinkleShade1",
            }}
            items={[
              {
                textContent: (
                  <p>
                    3 books in every box{" "}
                    <strong>expertly curated just for your reader</strong>.
                  </p>
                ),
                key: 1,
              },
              {
                textContent: (
                  <p>
                    Easily <strong>adjust your delivery schedule</strong> so
                    that it’s just right.
                  </p>
                ),
                key: 2,
              },
              {
                textContent: (
                  <p>
                    Rate your books so that{" "}
                    <strong>each box gets better every time</strong>.
                  </p>
                ),
                key: 3,
              },
            ]}
          />
          <Heading className={cls.HEADING}>Additional Box Contents</Heading>
          <StyledBullets
            css="padding-bottom: 1rem"
            iconProps={{
              name: IconName.STAR,
              fill: "periwinkleShade1",
            }}
            items={[
              {
                textContent: "Art print by a children’s book illustrator",
                key: 1,
              },
              { textContent: "Activities & personalized stickers", key: 2 },
              { textContent: "Parent Guide with tips and resources", key: 3 },
            ]}
          />
        </StyledGuidedSignUpCollapsible>
      </StyledDiv>
    </Theme>
  );
};

export default PlanSelectionPrepaidDetailsCollapsible;
